export const expressEventLinkRegex = /^https?:\/\/([\w-]{1,32}\.[\w-]{1,32})[^\s@]*$/gm; // TODO заметить на регулярку от BA

export const customRegistrationRegex = /^https?:\/\/([\w-]{1,32}\.[\w-]{1,32})[^\s@]*$/gm;
